import React, { type PropsWithChildren } from 'react';
import { useSalesNetwork } from 'utils/hooks/useSalesNetworks';

interface TitleMenuProps {
    title: string;
}

const TitleMenu: React.FC<PropsWithChildren<TitleMenuProps>> = ({ children, title }) => {
    const { isThermor } = useSalesNetwork();

    return (
        <group
            data-justify="center"
            data-align="center"
            data-gap="5"
            //data-elevation="1"
            //data-index="2"
            data-background="main-color-custom-lighter"
            data-backdrop=""
            data-wrap="no"
            //data-sticky="top"
        >
            <group
                data-wrap="no"
                data-space="10"
                data-space-vertical="30"
                data-direction="column"
                data-max-length="1440"
                data-gap="20"
            >
                <group data-gap="20">
                    {!isThermor && <group
                        data-height="40"
                        data-length="5"
                        data-background="main"
                    >
                    </group>}
                    <group
                        data-length="autofit"
                    >
                        <text data-color="main" data-text-size="xx-large">{title}</text>
                    </group>                   
                </group>
                 {children}

            </group>

        </group>

    )
}

export default TitleMenu;